import axiosLib from 'axios';
import logError from './logError';
import store from '@/store';

const axios = axiosLib.create({ timeout: process.env.NODE_ENV === 'production' ? 500000 : 0 });

axios.interceptors.request.use(

    async config => {

        const token = store.getters.xsrfToken;
        const accessToken = store.getters.accessToken;

        if (token) { config.headers['X-XSRF-TOKEN'] = token };
        if (accessToken) { config.headers.Authorization = `Bearer ${accessToken}`; }

        config.headers['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains; preload';
        config.headers['X-Content-Type-Options'] = 'nosniff';
        config.headers['X-Frame-Options'] = 'DENY';

        return config;

    },
    error => {
        return Promise.reject(error);
    }

)

axios.interceptors.response.use(

    async response => { return response; },
    async error => {
        if (error.config.data) {
            delete error.config.data;
        }

		const applicantToken = store.getters["applicant/applicantToken"];
		const applicationToken = store.getters["application/applicationToken"];

		const requestId = error?.requestId || null;

        logError(error, requestId, applicantToken, applicationToken);

        const status = error?.response?.status ?? error?.status;
        if (String(status) === '403' || String(status) === '401') {
            const [{ default: router }, { default: constructUrl }] = await Promise.all([
                import('@/router'),
                import('./constructUrl')
            ]);

            const tokenFromQuery = router.currentRoute?.query?.applicationToken;
            const token = applicationToken || tokenFromQuery;

            if (token && token.length) {
                router.push(constructUrl('Resume')).catch(() => {});
            } else {
                router.push({ name: 'ProductSelect' }).catch(() => {});
            }
        }

        return Promise.reject(error); 
    }

);

export default axios;
export { axios };